module.exports = __webpack_public_path__ + "static/media/play_arrow.b48ac65b.svg";